import * as messages from '@radnuc/messages';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
import './i18n'

export function translateHealthStatus(inputString: string, component: messages.Rad.HealthComponent) {
    let translation_output = inputString;
    if (component === messages.Rad.HealthComponent.RAD){
        //Break string into individual sentences
        //inputString = "Connected to 5 out of 6 detectors";
        //inputString = "Detectors 222-M014, 222-M018, and 222-M015 are not assigned in the current configuration. Assigned Detector 222-M016 is not connected.";
        const input_strings = inputString.split(/(?<!Connecting..)\.{1}([^.]|$)/g);
        translation_output = "";
        input_strings.forEach(status_element => {
            if(status_element === ""){
            } else if(status_element.match('not assigned in the current configuration')){
                translation_output += translate_rad_detector_not_assigned_string(status_element)+'. ';
            } else if(status_element.match('not connected')){
                translation_output += translate_rad_detector_not_connected(status_element)+'. ';
            } else if(status_element.match('Connected to')){
                translation_output += translate_rad_detector_connected_to(status_element)+'. ';
            } else if(status_element.match('Missing data from')){
                translation_output += translate_rad_detector_missing_data(status_element)+'. ';
            } else {
                translation_output += t(status_element,{ns:'trans'});
            }
        });
        //console.log(translation_output)
    } else if (component === messages.Rad.HealthComponent.NEUTRON){
            //Break string into individual sentences
            //inputString = "Connected to 5 out of 6 detectors";
            //inputString = "Detectors 222-M014, 222-M018, and 222-M015 are not assigned in the current configuration. Assigned Detector 222-M016 is not connected.";
            const input_strings = inputString.split(/(?<!Connecting..)\.{1}([^.]|$)/g);
            translation_output = "";
            input_strings.forEach(status_element => {
                if(status_element === ""){
                } else if(status_element.match('not assigned in the current configuration')){
                    translation_output += translate_rad_detector_not_assigned_string(status_element)+'. ';
                } else if(status_element.match('not connected')){
                    translation_output += translate_rad_detector_not_connected(status_element)+'. ';
                } else if(status_element.match('Connected to')){
                    translation_output += translate_rad_detector_connected_to(status_element)+'. ';
                } else if(status_element.match('Missing data from')){
                    translation_output += translate_rad_detector_missing_data(status_element)+'. ';
                } else if(status_element.match('Neutron detection operating with')){
                    translation_output += translate_neutron_detector_operating_with(status_element)+'. ';
                } else {
                    translation_output += t(status_element,{ns:'trans'});
                }
            });
            //console.log(translation_output)
    } else if (component === messages.Rad.HealthComponent.TMU){
        const input_strings = inputString.split(/(?<!Connecting..)\.{1}([^.]|$)/g);
        translation_output = "";
        input_strings.forEach(status_element => {
            if(status_element === ""){
            } else if(status_element.match('All PERMs at or above')){
                translation_output += translate_tmu_all_above(status_element)+'.';
            } else if(status_element.match('PERMs still not initialized')){
                translation_output += translate_tmu_status_not_initialized(status_element)+'. ';
            } else if(status_element.match('PERMs not updating')){
                translation_output += translate_tmu_status_not_updating(status_element)+'. ';
            } else {
                translation_output += t(status_element,{ns:'trans'});
            }
        });
    } else if (component === messages.Rad.HealthComponent.PCS){
        const input_strings = inputString.split(/(?<!Connecting..)\.{1}([^.]|$)/g);
        translation_output = "";
        input_strings.forEach(status_element => {
            if(status_element === ""){
            } else if(status_element.match('PERMs still not initialized')){
                translation_output += translate_tmu_status_not_initialized(status_element)+'. ';
            } else if(status_element.match('PERMs not updating')){
                translation_output += translate_tmu_status_not_updating(status_element)+'. ';
            } else {
                translation_output += t(status_element,{ns:'trans'});
            }
        });
    } else {
        translation_output = t(inputString,{ns:'trans'});
    }

    return translation_output
}

function translate_rad_detector_not_assigned_string(input: string){
    let buffer = input;
    let rx = /Detectors? (.*) (?:is|are)/g
    const rx_result = rx.exec(buffer);
    let translation_output = input;
    if(rx_result !== null){
        const detector_string = rx_result[1];
        //Test to see if there are multiple detectors
        if(detector_string.match('and')){
            let detector_trans_string = detector_string.replace('and',t('conjunction_and',{ns:'trans'}));
            translation_output = t("detector_not_assigned_plural",{detectors:detector_trans_string,ns:'trans'})
        } else {
            translation_output = t("detector_not_assigned_single",{detector:detector_string,ns:'trans'})
        }
    }
    return translation_output;

} withTranslation()

function translate_relative_location(input: string){
    if(input.match(/\(RIGHT\)/gi))
        input = input.replace(/\(RIGHT\)/gi,"("+t('RIGHT',{ns:'trans'}).toLowerCase()+")");
    if(input.match(/\(LEFT\)/gi))
        input = input.replace(/\(LEFT\)/gi,"("+t('LEFT',{ns:'trans'}).toLowerCase())+")";
    if(input.match(/\(TOP\)/gi))
        input = input.replace(/\(TOP\)/gi,"("+t('TOP',{ns:'trans'}).toLowerCase()+")");
    if(input.match(/\(BOTTOM\)/gi))
        input = input.replace(/\(BOTTOM\)/gi,"("+t('BOTTOM',{ns:'trans'}).toLowerCase()+")");
    return input;
}

function translate_rad_detector_not_connected(input: string){
    let buffer = input;
    let rx = /Assigned detectors? (.*) (?:is|are)/g
    const rx_result = rx.exec(buffer);
    let translation_output = input;
    if(rx_result !== null){
        const detector_string = rx_result[1];
        //Test to see if there are multiple detectors
        if(detector_string.match('and')){
            let detector_trans_string = detector_string.replace('and',t('conjunction_and',{ns:'trans'}));
            detector_trans_string = translate_relative_location(detector_trans_string)

            translation_output = t("detector_not_connected_plural",{detectors:detector_trans_string,ns:'trans'})
        } else {
            let detector_trans_string = translate_relative_location(detector_string)
            translation_output = t("detector_not_connected_single",{detector:detector_trans_string,ns:'trans'})
        }
    }
    return translation_output;

} withTranslation()

function translate_rad_detector_connected_to(input: string){
    let buffer = input;
    let rx = /Connected to (.*) out of (.*) detectors/g
    const rx_result = rx.exec(buffer);
    let translation_output = input;
    if(rx_result !== null){
        const detector_connected_string = rx_result[1];
        const detector_total_string = rx_result[2];
        translation_output = t("detector_connected_out_of",{connected:detector_connected_string,total:detector_total_string,ns:'trans'});
    }
    return translation_output;

} withTranslation()

function translate_rad_detector_missing_data(input: string){
    let buffer = input;
    let rx = /Missing data from (.*) detectors?/g
    const rx_result = rx.exec(buffer);
    let translation_output = input;
    if(rx_result !== null){
        const detector_missing = rx_result[1];
        translation_output = t("detector_missing_data",{number:detector_missing,ns:'trans'});
    }
    return translation_output;

} withTranslation()

function translate_neutron_detector_operating_with(input: string){
    let buffer = input;
    let rx = /Neutron detection operating with 1-in-(.*)-hours CFAR/g
    const rx_result = rx.exec(buffer);
    let translation_output = input;
    if(rx_result !== null){
        const detector_cfar = rx_result[1];
        translation_output = t("neutron_operating_cfar",{number:detector_cfar,ns:'trans'});
    }
    return translation_output;

} withTranslation()

function translate_tmu_all_above(input: string){
    let buffer = input;
    let rx = /All PERMs at or above (.*) deg C/g
    const rx_result = rx.exec(buffer);
    let translation_output = input;
    if(rx_result !== null){
        const number_string = rx_result[1];
        translation_output = t("tmu_all_above",{number:number_string,ns:'trans'})
    }
    return translation_output;

} withTranslation()

function translate_tmu_status_not_updating(input: string){
    let buffer = input;
    let rx = /TMU status for (.*) PERMs not updating/g
    const rx_result = rx.exec(buffer);
    let translation_output = input;
    if(rx_result !== null){
        const number_string = rx_result[1];
        translation_output = t("tmu_not_updating",{number:number_string,ns:'trans'})
    }
    return translation_output;

} withTranslation()

function translate_tmu_status_not_initialized(input: string){
    let buffer = input;
    let rx = /TMU status for (.*) PERMs still not initialized/g
    const rx_result = rx.exec(buffer);
    let translation_output = input;
    if(rx_result !== null){
        const number_string = rx_result[1];
        translation_output = t("tmu_not_initialized",{number:number_string,ns:'trans'})
    }
    return translation_output;

} withTranslation()
